import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from '../../../cer/cer-data/cer-data-types';

export class ProductThemeForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'temakoder', dataApiName: 'ProductTheme', text: 'Temakoder', textSingular: 'Temakode',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history']
      },
      fieldMetadata: [
        { name: 'num', text: 'Temakode', tooltipText: 'Kode for tema', allowEdit: true, allowEditOnAdd: true, required: true, widthType: FieldWidthEnum.XS, orderBy: 'Ascending', orderByPriority: 1, filterOperator: 'startswith' },
        { name: 'description', text: 'Beskrivelse', format: 'Text', widthType: FieldWidthEnum.XL }
      ]
    });

  }
}
